export interface TooltipSection {
  bulletStyle?: TooltipBulletStyle;
  bulletColor?: string;
  rows?: TooltipRow[];
}

export interface TooltipRow {
  items: TooltipItem[];
}

export interface TooltipItem {
  text: string;
  type: TooltipItemType;
  // Intended for TooltipItemType=Data theme for text highlight
  theme?: string;
}

export enum TooltipItemType {
  Data = `data`,
  Strong = `strong`,
  Text = `text`,
  Detail = `detail`,
}

export enum TooltipBulletStyle {
  Dash = `dash`,
  Solid = `solid`,
}
